import React from 'react';
import { Modal } from 'react-bootstrap';
import { getAgreementDiscountedCost } from '../../utils';

const backdropStyle = {
  position: 'fixed',
  zIndex: 1040,
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: '#000',
  opacity: 0.5,
};

const UpgradeAlert = ({
  show,
  agreementType,
  referrer,
  planType,
  hidePlanModal,
  exitedPlanModal,
  handlePurchase,
  handleViewOptions,
}) => {
  let price = '$150';

  if (referrer.includes('cdbaby') || referrer.includes('soundrop')) {
    price = '$150';
  }

  return (
    <Modal
      dialogClassName="user-plan-modal upgrade-alert-modal"
      show={show}
      onHide={hidePlanModal}
      onExited={exitedPlanModal}
      renderBackdrop={() => <div style={backdropStyle} />}
    >
      <Modal.Header closeButton />
      <Modal.Body>
        <div className="content">
          <div className="heading">It's time to upgrade.</div>
          <p>
            {agreementType === 3
              ? 'Only Premium subscribers can create this agreement.'
              : 'To create premium agreements, you will need to upgrade to a Premium subscription or buy an individual agreement.'}
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="buttons">
          {(agreementType === 1 || agreementType === 2) && (
            <button className="negative" onClick={handlePurchase}>
              Buy and Create 1 Single Agreement -{' '}
              {`$${getAgreementDiscountedCost(referrer)}`}
            </button>
          )}

          <button onClick={handleViewOptions}>
            Subscribe And Create Unlimited Agreements {price}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default UpgradeAlert;



// WEBPACK FOOTER //
// src/components/UserPlan/UpgradeAlert.jsx